import { LocalStorageDataModel } from "@Constants/local-storage-data-model";
import { Env, getDataFromLocalStorage } from "@Src/utils/globalUtilities";
import { APIEnv } from "./baseInterfaces";
import { HOME_API_CONSTANTS } from "@Constants/api-constants/home/home.constant";
import { postData } from "./global.service";
import { ENDMILE_API_FIELD_ID_MAPPING_LIST } from "@Constants/api-constants/endMileAPI.event.list";
import { NETCORE_API_FIELD_ID_MAPPING_LIST } from "@Constants/api-constants/netcore.eventList";

declare var smartech: Function;

export function createEndmileAPITrackObject(
  event: string,
  fields: any,
  userEmail?: string
) {
  let email =
    userEmail || getDataFromLocalStorage(LocalStorageDataModel.EMAIL) || "";

  let payload = {
    requestmethod: "AddSubscriberToList",
    details: {
      emailaddress: email,
      event_name: event,
      mailinglist: "1",
      format: "html",
      confirmed: "yes",
      customfields: { items: fields },
    },
  };
  return payload;
}

export function postEndmileAPIEventTrack(data: any) {
  postData(HOME_API_CONSTANTS.ENDMILE_EVENT_TRACK, data, APIEnv.ENDMILE)
    .then((res) => {})
    .catch((err) => {});
}

export function postNewEndmileAPIEventTrack(data: any) {
  postData(HOME_API_CONSTANTS.NEW_ENDMILE_EVENT_TRACK, data, APIEnv.ENDMILE)
    .then((res) => {})
    .catch((err) => {});
}
